// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersVenue_filters-venue__7wa3j {
  max-width: 300px;
  width: 100%;
}

@media only screen and (max-width: 1200px) {
  .FiltersVenue_filters-venue__7wa3j {
    max-width: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueList/Components/FiltersVenue/FiltersVenue.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE;IACE,kBAAA;EACF;AACF","sourcesContent":[".filters-venue {\n  max-width: 300px;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1200px) {\n  .filters-venue {\n    max-width: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-venue": `FiltersVenue_filters-venue__7wa3j`
};
export default ___CSS_LOADER_EXPORT___;
